export interface ControlCommand {
  type: 'pause' | 'resume' | 'stop' | 'speed' | 'rewind' | 'skip' | 'replay' | 'seek';
  payload?: any;
  timestamp: number;
}

export interface ControlResponse {
  success: boolean;
  action: string;
  data?: any;
  error?: string;
  timestamp: number;
}

export interface SpeedChangeCommand extends ControlCommand {
  type: 'speed';
  payload: {
    speed: number; // 0.5 to 2.0
  };
}

export interface SeekCommand extends ControlCommand {
  type: 'seek';
  payload: {
    chunkIndex: number;
    position?: number; // seconds within chunk
  };
}

export interface ControlServerConfig {
  port: number;
  enableCors: boolean;
  logRequests: boolean;
  maxConnections?: number;
}